import React from "react";
import BlockRenderer from "../builder/webflow/BlockRenderer";
import { Link } from "react-router-dom";

export default function ThemeRenderer({ theme, mode }) {
  if (!theme?.site?.pages) return <div>No pages found</div>;

  const pages = theme.site.pages;
  return (
    <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
      {/* HEADER */}
      <header
        style={{
          padding: "20px",
          background: theme.themeVars.backgroundGradient,
          color: "white",
          borderRadius: "10px",
          marginBottom: "30px"
        }}
      >
        <h2>{theme.header.logoText}</h2>

        <nav>
          {theme.header.menu.map((m, i) => (
            <Link
              key={i}
              to={`/theme/${theme.themeId}/${m.slug}`}
              style={{ margin: "0 15px", color: "white", textDecoration: "none" }}
            >
              {m.title}
            </Link>
          ))}
        </nav>
      </header>

      {/* This component doesn't render pages itself in preview mode */}
      {mode !== "preview" &&
        Object.values(pages).map(page => (
          <div key={page.slug} style={{ marginBottom: "60px" }}>
            {page.blocks.map((block, i) => (
              <BlockRenderer block={block} key={i} />
            ))}
          </div>
        ))}

      {/* FOOTER */}
      <footer
        style={{
          background: theme.themeVars.darkBackground,
          color: theme.themeVars.darkText,
          padding: "40px",
          borderRadius: "10px",
          marginTop: "30px"
        }}
      >
        <p>{theme.footer.about}</p>
        <p>{theme.footer.contactInfo.address}</p>
      </footer>
    </div>
  );
}

/* Export block wrapper for ThemePreview */
ThemeRenderer.Block = function ({ block }) {
  return <BlockRenderer block={block} />;
};
